import { useLocation, useNavigate } from 'react-router-dom'
import { useArchiveFloorRule, useFloorRules, useFloorRulesWithHistory } from '~/api/app/floor-rules.api'
import { useScopePermissions } from '~/auth/useScopePermissions'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { useScopeCurrency } from '~/hooks/useScopeCurrency.hooks'
import { PureFloorPricePage } from './PureFloorPricePage'

export const FloorPricePage: React.FunctionComponent = () => {
  const navigate = useNavigate()
  const breadcrumbs = useBreadcrumbs()
  const currencySymbol = useScopeCurrency()
  const { pathname } = useLocation()
  /* Creating and archiving a rule are owner-only at the API — a rule is shared, so both are decisions
     about every stack that could reach for it. Reading the list stays open. */
  const { canCreate, canEdit, canArchive, disabledReason } = useScopePermissions()

  const { data: floorRules, isFetching, isError } = useFloorRules(true)
  const { data: floorRulesHistory } = useFloorRulesWithHistory()
  const { mutateAsync: archiveFloorRule, isPending: isArchiving } = useArchiveFloorRule({
    successToast: 'Floor price rule archived',
    errorToast: 'Could not archive this floor price rule',
  })

  return (
    <PureFloorPricePage
      floorPriceRules={floorRules}
      currencySymbol={currencySymbol}
      isLoading={isFetching}
      isError={isError}
      breadcrumbs={breadcrumbs}
      onCreateRule={() => navigate(`${pathname}/new`)}
      onEditRule={(id: string) => navigate(`${pathname}/edit/${id}`)}
      floorPriceRulesHistory={floorRulesHistory}
      onArchiveRule={(id: string) => archiveFloorRule({ id, archived: true })}
      isArchiving={isArchiving}
      onNavigateToArchived={() => navigate(`${pathname}/archived`)}
      canCreate={canCreate}
      canEdit={canEdit}
      canArchive={canArchive}
      permissionDisabledReason={disabledReason}
    />
  )
}
